/* ============================================================================
   CLIPREX storefront logic (Shopify theme build).

   Gallery model — SLOTS:
     slot 0    the video, when the product has one
     slot 1..n the SHARED (non-variant) images
   slotIndex is where the shopper is. Swiping moves it; thumbs set it.

   Colorway selection does NOT move it. Picking a colour PREVIEWS that
   colorway's photo behind a countdown bar and then returns to whatever slot
   they were on — including the video. The variant photos are deliberately not
   slots of their own, which is what makes "return to where they were" well
   defined rather than "return to the cover shot".

   hasHook stays TRUE even on a page that opens on one side; CFG.defaultHook
   decides which. Collapsing hasHook to false maps both variants of a colour
   onto one key and lets whichever appears last silently win.
   ============================================================================ */
(function () {
  const CFG = window.CLIPREX_CONFIG || {};

  const COLOR_ORDER = ["Red", "Black", "Blue"];
  const colorHex = { Red: "#e0352b", Black: "#1c1c20", Blue: "#2f5fe0" };
  const themes = {
    Red:   { accent: "#e0352b", accent2: "#ff6a4d", soft: "#fdeceb", glow: "224,53,43" },
    Black: { accent: "#1c1c20", accent2: "#54555f", soft: "#eef0f5", glow: "84,85,95"  },
    Blue:  { accent: "#2f5fe0", accent2: "#5b8bff", soft: "#eaf0ff", glow: "47,95,224"  },
  };
  const bundles = [
    { key: "1", name: "Single", units: 1, pct: 0,    badge: "" },
    { key: "2", name: "Duo",    units: 2, pct: 0.10, badge: "" },
    { key: "3", name: "Trio",   units: 3, pct: 0.15, badge: "Popular" },
    { key: "5", name: "Crew",   units: 5, pct: 0.25, badge: "" },
  ];

  // Published for snippets/cliprex-cart.liquid, which predicts what a cart
  // total becomes after adding one more item. The ladder is a whole-cart
  // quantity rule, so adding a $5 hook to a 2-clip cart moves the order into
  // the 3+ tier and takes the total DOWN. One copy of these numbers only.
  window.CLIPREX_TIERS = bundles.map((b) => ({ units: b.units, pct: b.pct }));

  const hasColor = CFG.hasColor === true;
  const hasHook = CFG.hasHook === true;
  const unit1 = CFG.unitSingular || "clip";
  const unitN = CFG.unitPlural || "clips";

  // How long a colorway preview holds before returning to the shopper's slot.
  const PREVIEW_MS = 3000;

  const currencyCode = CFG.currencyCode || "USD";
  let moneyFmt;
  try { moneyFmt = new Intl.NumberFormat(undefined, { style: "currency", currency: currencyCode }); }
  catch (e) { moneyFmt = new Intl.NumberFormat(undefined, { style: "currency", currency: "USD" }); }
  const domain = CFG.domain || "";

  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const money = (n) => moneyFmt.format(n || 0);

  /* ---- responsive images --------------------------------------------------
     Gallery URLs arrive as Shopify CDN links ending in ?v=...&width=1400 and
     the main image is swapped by JS. A srcset baked in by Liquid would go
     stale on the first colorway tap — and the browser PREFERS srcset over
     src, so the stale one would win and the tap would appear to do nothing.
     Rebuild both from the same URL on every swap. */
  const SRCSET_W = [400, 600, 800, 1200, 1600];
  const GALLERY_SIZES = "(min-width: 960px) 55vw, 100vw";

  function atWidth(url, w) {
    if (!url) return "";
    return /[?&]width=\d+/.test(url)
      ? url.replace(/([?&])width=\d+/, "$1width=" + w)
      : url + (url.indexOf("?") > -1 ? "&" : "?") + "width=" + w;
  }
  function srcsetFor(url, widths) {
    if (!url) return "";
    return (widths || SRCSET_W).map((w) => atWidth(url, w) + " " + w + "w").join(", ");
  }

  const variants = {};
  (CFG.variantList || []).forEach((v) => {
    const color = hasColor ? (v.color || "_") : "_";
    const hook = hasHook ? (/without/i.test(v.hook || "") ? "nohook" : "hook") : "_";
    (variants[color] = variants[color] || {})[hook] = {
      id: String(v.id), price: Number(v.price), img: v.image,
    };
  });
  const colors = hasColor
    ? COLOR_ORDER.filter((c) => variants[c])
    : Object.keys(variants);

  const variantImgs = new Set();
  Object.values(variants).forEach((byHook) =>
    Object.values(byHook).forEach((v) => { if (v.img) variantImgs.add(v.img); })
  );
  const sharedGallery = (CFG.gallery || []).filter((url) => !variantImgs.has(url));

  const defaultPack = bundles.some((b) => b.key === String(CFG.defaultPack))
    ? String(CFG.defaultPack)
    : "1";
  const defaultHook = CFG.defaultHook === "nohook" ? "nohook" : "hook";

  const state = {
    color: hasColor && variants.Black ? "Black" : colors[0],
    hook: hasHook ? defaultHook : "_",
    bundle: defaultPack,
  };

  function variant() {
    const byColor = variants[state.color] || {};
    return byColor[state.hook] || byColor.hook || byColor.nohook || byColor._ ||
      Object.values(byColor)[0];
  }
  function unitPrice() { const v = variant(); return v ? v.price : 0; }
  function coverUrl() {
    const v = variant();
    return sharedGallery[0] || (CFG.gallery && CFG.gallery[0]) || (v && v.img) || "";
  }
  function colorImage(c) {
    const byHook = variants[c] || {};
    return (byHook.nohook && byHook.nohook.img) ||
      (byHook.hook && byHook.hook.img) ||
      (byHook._ && byHook._.img) || "";
  }

  function bundleMath(b) {
    const full = unitPrice() * b.units;
    const total = b.pct ? full * (1 - b.pct) : full;
    return { full, total, perUnit: total / b.units, save: full - total };
  }
  function checkoutUrl() {
    const b = bundles.find((x) => x.key === state.bundle);
    const v = variant();
    return v ? `${domain}/cart/${v.id}:${b.units}` : "#";
  }
  function applyTheme() {
    const t = themes[state.color] || themes.Black;
    const r = document.documentElement;
    r.style.setProperty("--accent", t.accent);
    r.style.setProperty("--accent2", t.accent2);
    r.style.setProperty("--accent-soft", t.soft);
    r.style.setProperty("--glow", t.glow);
  }

  function preselectFromUrl() {
    const m = window.location.search.match(/[?&]variant=(\d+)/);
    if (!m) return;
    (CFG.variantList || []).forEach((v) => {
      if (String(v.id) !== m[1]) return;
      if (hasColor && v.color) state.color = v.color;
      if (hasHook) state.hook = /without/i.test(v.hook || "") ? "nohook" : "hook";
    });
  }

  function pickColor(c, { scrollTo = null } = {}) {
    if (!variants[c]) return;
    state.color = c;
    applyTheme();
    renderAll();
    if (scrollTo === "buybox") scrollToBuybox();
    else if (scrollTo === "gallery") scrollToGallery();
    const img = colorImage(c);
    if (img) previewColor(img);
  }

  function renderColors() {
    if (!hasColor) return;
    const wrap = $("#colors"); if (!wrap) return;
    wrap.innerHTML = "";
    colors.forEach((c) => {
      const btn = document.createElement("button");
      btn.type = "button";
      btn.className = "swatch" + (state.color === c ? " is-active" : "");
      btn.style.setProperty("--sw", colorHex[c] || "#888");
      btn.setAttribute("aria-label", c);
      btn.setAttribute("aria-pressed", state.color === c ? "true" : "false");
      btn.title = c;
      // Bring the photo into view first — the swatches sit ~350px below it on
      // a phone, so without this the preview plays where nobody is looking.
      // scrollToGallery() no-ops when the image is already on screen.
      btn.onclick = () => pickColor(c, { scrollTo: "gallery" });
      wrap.appendChild(btn);
    });
    const cn = $("#colorName"); if (cn) cn.textContent = state.color;
  }
  function renderHook() {
    if (!hasHook) return;
    $$("#hook .seg").forEach((el) => {
      const on = el.dataset.hook === state.hook;
      el.classList.toggle("is-active", on);
      el.setAttribute("aria-pressed", on ? "true" : "false");
    });
  }
  function renderBundles() {
    const wrap = $("#bundles"); if (!wrap) return;
    wrap.innerHTML = "";
    bundles.forEach((b) => {
      const m = bundleMath(b);
      const on = state.bundle === b.key;
      const card = document.createElement("button");
      card.type = "button";
      card.className = "bundle" + (on ? " is-active" : "");
      card.setAttribute("aria-pressed", on ? "true" : "false");
      card.setAttribute("aria-label",
        `${b.units} ${b.units > 1 ? unitN : unit1}, ${money(m.total)} total, ` +
        `${money(m.perUnit)} each` + (b.pct ? `, ${Math.round(b.pct * 100)}% off` : ""));
      card.onclick = () => { state.bundle = b.key; renderAll(); };
      card.innerHTML =
        (b.badge ? `<span class="bundle__badge">${b.badge}</span>` : "") +
        `<span class="bundle__n">${b.units}</span>` +
        (b.pct
          ? `<span class="bundle__off">&minus;${Math.round(b.pct * 100)}%</span>`
          : `<span class="bundle__per">${money(m.perUnit)}</span>`);
      wrap.appendChild(card);
    });
  }
  function renderSummary() {
    const b = bundles.find((x) => x.key === state.bundle);
    const m = bundleMath(b);
    const set = (id, txt) => { const el = $(id); if (el) el.textContent = txt; };
    set("#price", money(m.total));
    const show = m.save > 0.001;
    const cmp = $("#compare"), sv = $("#saveTag");
    if (cmp) { cmp.style.display = show ? "" : "none"; cmp.textContent = money(m.full); }
    if (sv) { sv.style.display = show ? "" : "none"; sv.textContent = `Save ${money(m.save)}`; }
    const url = checkoutUrl();
    const main = $("#ctaMain");
    if (main) { main.textContent = `Add to cart · ${money(m.total)}`; main.href = url; }
    const pp = $("#ctaPaypal"); if (pp) pp.href = url;
    const sc = $("#stickyCta"); if (sc) sc.href = url;
    set("#stickyPrice", money(m.total));
    const sn = $("#stickyName");
    if (sn) {
      const bits = [];
      if (b.units > 1) bits.push(`${b.units}-pack`);
      if (hasColor) bits.push(state.color);
      if (bits.length) sn.textContent = bits.join(" · ");
    }
  }

  // ---- Gallery -------------------------------------------------------------
  let frontImg = null;
  let videoEl = null;
  let slots = [];
  let slotIndex = 0;
  let previewTimer = null;

  function buildSlots() {
    slots = [];
    if (videoEl) slots.push({ kind: "video" });
    sharedGallery.forEach((url) => slots.push({ kind: "img", url: url }));
  }

  function setThumbActive(url) {
    $$("#thumbs .thumb").forEach((t) =>
      t.classList.toggle("is-active", !!url && t.dataset.src === url));
  }

  function showVideo() {
    if (!videoEl) return;
    $$(".gallery__main .gallery__img").forEach((i) => i.classList.remove("is-front"));
    videoEl.classList.add("is-front");
    setThumbActive(null);
    const vt = $("#thumbs .thumb--vid"); if (vt) vt.classList.add("is-active");
    const play = videoEl.play();
    if (play && play.catch) play.catch(() => {}); // autoplay refusal is fine
  }

  function setMainImage(url) {
    const host = $(".gallery__main"); if (!host || !url) return;
    if (videoEl) { videoEl.classList.remove("is-front"); videoEl.pause(); }
    const layers = $$(".gallery__img", host);
    setThumbActive(url);
    if (!layers.length) return;

    const paint = (el) => {
      el.sizes = GALLERY_SIZES;
      el.srcset = srcsetFor(url);
      el.src = atWidth(url, 1200);
    };
    if (layers.length < 2) { paint(layers[0]); layers[0].classList.add("is-front"); return; }

    if (!frontImg) frontImg = layers.find((i) => i.classList.contains("is-front")) || layers[0];
    // Compare the resolved 1200 variant, not the raw url, or a repeat
    // selection re-runs the crossfade against itself.
    if (frontImg.getAttribute("src") === atWidth(url, 1200) &&
        frontImg.classList.contains("is-front")) return;
    const back = layers.find((i) => i !== frontImg) || layers[0];
    const reveal = () => {
      paint(back);
      requestAnimationFrame(() => requestAnimationFrame(() => {
        back.classList.add("is-front");
        frontImg.classList.remove("is-front");
        frontImg = back;
      }));
    };
    const pre = new Image();
    pre.onload = reveal; pre.onerror = reveal;
    pre.srcset = srcsetFor(url);
    pre.sizes = GALLERY_SIZES;
    pre.src = atWidth(url, 1200);
  }

  // Move to a gallery slot. remember:false is used by the preview's own
  // return trip, so it restores the view without redefining "where they were".
  function goToSlot(i, { remember = true } = {}) {
    if (!slots.length) return;
    const n = ((i % slots.length) + slots.length) % slots.length;
    if (remember) { clearPreview(); slotIndex = n; }
    const s = slots[n];
    if (s.kind === "video") showVideo();
    else setMainImage(s.url);
  }

  /* ---- colorway preview ---------------------------------------------------
     Show the picked colorway for PREVIEW_MS behind a shrinking bar, then go
     back to the slot the shopper was on. The bar is built here rather than in
     the sections so both pages get it from one place. */
  function ensureBar() {
    const host = $(".gallery__main"); if (!host) return null;
    let bar = $(".cdbar", host);
    if (!bar) {
      bar = document.createElement("span");
      bar.className = "cdbar";
      bar.setAttribute("aria-hidden", "true");
      host.appendChild(bar);
    }
    return bar;
  }
  function clearPreview() {
    if (previewTimer) { clearTimeout(previewTimer); previewTimer = null; }
    const bar = $(".cdbar");
    if (bar) bar.classList.remove("is-running");
  }
  function previewColor(url) {
    clearPreview();
    setMainImage(url);
    const bar = ensureBar();
    if (bar) {
      // Drop the class and force a reflow so the animation restarts even when
      // the shopper taps a second colour mid-countdown.
      bar.classList.remove("is-running");
      void bar.offsetWidth;
      bar.classList.add("is-running");
    }
    previewTimer = setTimeout(() => {
      previewTimer = null;
      if (bar) bar.classList.remove("is-running");
      goToSlot(slotIndex, { remember: false });
    }, PREVIEW_MS);
  }

  function renderThumbs() {
    const wrap = $("#thumbs"); if (!wrap) return;
    wrap.innerHTML = "";

    slots.forEach((s, i) => {
      const t = document.createElement("button");
      t.type = "button";
      if (s.kind === "video") {
        t.className = "thumb thumb--vid";
        t.setAttribute("aria-label", "Play the product video");
        const poster = videoEl.getAttribute("poster") || "";
        t.innerHTML =
          (poster
            ? `<img src="${atWidth(poster, 200)}" srcset="${srcsetFor(poster, [100, 200, 300])}" sizes="70px" alt="" loading="lazy" decoding="async">`
            : "") +
          `<span class="thumb__play" aria-hidden="true"></span>`;
      } else {
        t.className = "thumb";
        t.dataset.src = s.url;
        t.innerHTML = `<img src="${atWidth(s.url, 200)}" srcset="${srcsetFor(s.url, [100, 200, 300])}" sizes="70px" alt="View ${i + 1}" loading="lazy" decoding="async">`;
      }
      t.onclick = () => goToSlot(i);
      wrap.appendChild(t);
    });
  }

  /* ---- swipe --------------------------------------------------------------
     Listeners are passive and never preventDefault, so vertical page scroll
     stays native. Direction is locked on the first 10px of travel and the
     slot only changes on touchend, which keeps a diagonal thumb-scroll from
     flicking the gallery. */
  function initSwipe() {
    const host = $(".gallery__main");
    if (!host || slots.length < 2) return;
    let x0 = null, y0 = null, axis = null;

    host.addEventListener("touchstart", (e) => {
      if (e.touches.length !== 1) { x0 = null; return; }
      x0 = e.touches[0].clientX;
      y0 = e.touches[0].clientY;
      axis = null;
    }, { passive: true });

    host.addEventListener("touchmove", (e) => {
      if (x0 === null || e.touches.length !== 1) return;
      const dx = e.touches[0].clientX - x0;
      const dy = e.touches[0].clientY - y0;
      if (axis === null && (Math.abs(dx) > 10 || Math.abs(dy) > 10)) {
        axis = Math.abs(dx) > Math.abs(dy) ? "x" : "y";
      }
    }, { passive: true });

    host.addEventListener("touchend", (e) => {
      if (x0 === null) return;
      const t = e.changedTouches[0];
      const dx = t.clientX - x0;
      const dy = t.clientY - y0;
      x0 = null;
      if (axis !== "x") return;
      if (Math.abs(dx) < 45 || Math.abs(dx) <= Math.abs(dy)) return;
      goToSlot(slotIndex + (dx < 0 ? 1 : -1));
    }, { passive: true });
  }

  function scrollToBuybox() {
    const b = $("#buybox"); if (b) b.scrollIntoView({ behavior: "smooth", block: "start" });
  }

  /* Bring the photo back after a colorway change — but only when it is off
     screen. On a phone the gallery sits directly above the buy box, so a
     shopper tapping a swatch can often already see it; scrolling then is
     motion for nothing and pushes the swatch they tapped out of reach. */
  function scrollToGallery() {
    const g = $(".gallery");
    const pic = $(".gallery__main") || g;
    if (!g || !pic) return;
    const r = pic.getBoundingClientRect();
    const shown = Math.min(r.bottom, window.innerHeight) - Math.max(r.top, 0);
    if (r.height > 0 && shown >= r.height * 0.6) return;
    g.scrollIntoView({ behavior: "smooth", block: "start" });
  }

  function renderAll() { renderColors(); renderHook(); renderBundles(); renderSummary(); }

  function injectStyles() {
    const style = document.createElement("style");
    style.textContent = `
      .gallery__main { position: relative; }
      .gallery, #buybox, #reviews { scroll-margin-top: 84px; }
    `;
    document.head.appendChild(style);
  }

  /* ---- delivery date ------------------------------------------------------
     Six business days out. Liquid has no date arithmetic that skips weekends,
     so the sections server-render +8 calendar days as the no-JS fallback and
     this overwrites it. Uses the visitor's clock, not the shop's timezone. */
  function initDeliveryDate() {
    const els = $$("[data-delivery-date]");
    if (!els.length) return;
    const d = new Date();
    let added = 0;
    while (added < 6) {
      d.setDate(d.getDate() + 1);
      const day = d.getDay();
      if (day !== 0 && day !== 6) added++;
    }
    let txt;
    try {
      txt = new Intl.DateTimeFormat(undefined, {
        weekday: "short", month: "short", day: "numeric",
      }).format(d);
    } catch (e) {
      txt = d.toDateString();
    }
    els.forEach((el) => { el.textContent = txt; });
  }

  // ---- belt-hook add-on row (homepage only) -------------------------------
  function addonPct(qty) {
    let pct = 0;
    bundles.forEach((b) => { if (qty >= b.units && b.pct > pct) pct = b.pct; });
    return pct;
  }

  function initAddon() {
    const row = $(".addon"); if (!row) return;
    const unit = Number(row.getAttribute("data-addon-price")) || 0;
    const nEl = row.querySelector("[data-addon-qty-n]");
    const subEl = row.querySelector("[data-addon-sub]");
    const note = row.getAttribute("data-addon-note") || "";
    const MAX = 10;
    if (!nEl) return;

    function draw() {
      const qty = Number(nEl.textContent) || 1;
      const pct = addonPct(qty);
      const total = unit * qty * (1 - pct);
      if (subEl) {
        subEl.textContent = pct > 0
          ? `${money(total)} · save ${Math.round(pct * 100)}%`
          : `${money(total)}${note ? " · " + note : ""}`;
      }
      row.querySelectorAll("[data-addon-qty]").forEach((b) => {
        const dir = b.getAttribute("data-addon-qty");
        b.disabled = (dir === "dec" && qty <= 1) || (dir === "inc" && qty >= MAX);
      });
    }

    row.querySelectorAll("[data-addon-qty]").forEach((btn) => {
      btn.onclick = () => {
        const cur = Number(nEl.textContent) || 1;
        const next = btn.getAttribute("data-addon-qty") === "inc" ? cur + 1 : cur - 1;
        nEl.textContent = String(Math.min(MAX, Math.max(1, next)));
        draw();
      };
    });
    draw();
  }

  // ---- sticky buy bar ------------------------------------------------------
  function initSticky() {
    const sticky = $("#sticky"); if (!sticky) return;
    const hero = $(".hero");
    const mainCta = $("#ctaMain");
    let heroPassed = !hero;
    let ctaVisible = false;

    const sync = () => sticky.classList.toggle("is-visible", heroPassed && !ctaVisible);

    if (hero) {
      new IntersectionObserver(([e]) => {
        heroPassed = !e.isIntersecting && e.boundingClientRect.top < 0;
        sync();
      }, { threshold: 0 }).observe(hero);
    }
    if (mainCta) {
      new IntersectionObserver(([e]) => {
        ctaVisible = e.isIntersecting;
        sync();
      }, { threshold: 0.4 }).observe(mainCta);
    }
    sync();
  }

  function initChrome() {
    initAddon();
    initDeliveryDate();

    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => { if (e.isIntersecting) { e.target.classList.add("in"); io.unobserve(e.target); } });
    }, { threshold: 0.15 });
    $$(".reveal").forEach((el) => io.observe(el));

    $$('[data-scroll="buybox"]').forEach((el) => {
      el.onclick = (ev) => {
        if (!$("#buybox")) return; // no buy box here — let the href do its job
        ev.preventDefault();
        scrollToBuybox();
      };
    });
  }

  /* ---- gallery video ------------------------------------------------------
     snippets/cliprex-video.liquid emits every mp4 rendition Shopify exposes as
     JSON in data-sources; this picks one. Budget is CSS width, not device
     pixels: the box is ~348px on a phone, so anything past 480 lines is spent
     on pixels it cannot show. Shopify does not reliably expose every
     rendition it transcoded, so take the largest within budget and fall back
     to the smallest available rather than assuming a ladder exists.

     muted is set as a PROPERTY as well as an attribute, before src: iOS has
     refused inline autoplay when only the attribute is present. */
  function initVideo() {
    videoEl = $("#mainVideo");
    if (!videoEl) return;

    let list = [];
    try { list = JSON.parse(videoEl.getAttribute("data-sources") || "[]"); } catch (e) {}
    list = list.filter((s) => s && s.u);
    if (!list.length) { videoEl = null; return; }
    list.sort((a, b) => (a.h || 0) - (b.h || 0));

    const budget = window.innerWidth >= 760 ? 720 : 480;
    const pick = list.filter((s) => (s.h || 0) <= budget).pop() || list[0];

    let reduce = false;
    try { reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches; } catch (e) {}

    videoEl.muted = true;
    videoEl.playsInline = true;
    videoEl.src = pick.u;

    if (reduce) {
      videoEl.preload = "metadata";
      videoEl.setAttribute("controls", "");
      videoEl.loop = false;
    } else {
      videoEl.preload = "auto";
      videoEl.autoplay = true;
    }
  }

  function init() {
    initChrome();

    if (!$("#buybox") || !colors.length) return;

    injectStyles();
    initVideo();
    buildSlots();
    preselectFromUrl();
    $$("#hook .seg").forEach((el) => {
      el.onclick = () => { state.hook = el.dataset.hook; renderAll(); };
    });
    renderThumbs();
    applyTheme();
    // Paint the cover into the image layers first so slot 0 has something to
    // cross-fade from, then land on slot 0 (the video when there is one).
    setMainImage(coverUrl());
    slotIndex = 0;
    goToSlot(0);
    renderAll();
    initSwipe();

    $$("[data-pickcolor]").forEach((el) => {
      // From the showcase, far below the buy box — carry the shopper to the
      // buy box, where the decision gets made.
      el.onclick = () => pickColor(el.dataset.pickcolor, { scrollTo: "buybox" });
    });

    initSticky();
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();
